import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import { GrEmptyCircle} from "react-icons/gr";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";
import { FaRegTimesCircle } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";
import { IoTriangleOutline } from "react-icons/io5";
import ProgressBar from 'react-bootstrap/ProgressBar';
import {Link, useNavigate} from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useState,useCallback,useEffect } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import {useParams}  from 'react-router-dom';
import Footer from './Common_Components/Footer';

const KatakanaQuiz = () => {
  const {quiz_type_name,quiz_type_id} = useParams();
const Quiz_type_id = quiz_type_id
  const [activePage, setActivePage] = useState("Learning");
    const now = 20;
    const navigate = useNavigate();
    const [levels, setLevels] = useState([]);
    const [categories, setCategories] = useState([]);

    const authToken = localStorage.getItem("AuthToken");
    // console.log(authToken);
  
    const fetchLevelData = useCallback(async () => {
      try {
        const response = await fetch(
          `https://api.japaking.online/api/levels`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const responseData = await response.json();
        const data = responseData.message.levels;
  
        const Quiz_id = parseInt(Quiz_type_id)
        console.log(Quiz_id)
        const filtered = data.filter((level) => level.quiz_type_id === Quiz_id);
        setLevels(filtered );
        console.log(filtered )
      
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    },  [authToken, quiz_type_id]);
  
  
  
  
    const fetchCategoriesData = useCallback(async () => {
      try {
  
        if (levels.length === 0) {
          console.log("Levels data is still loading...");
          return;
        }
  
        const response = await fetch(
          `https://api.japaking.online/api/categories`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const ResponseData = await response.json();
        const  data = ResponseData.message.categories
        console.log('Fetched data:',data);
  
        const targetCategories = ['Reading','Writing'];
  
        const filteredCategories = data.filter((category) => {
          const normalizedCategoryName = category.category_name.trim().toLowerCase();
          return targetCategories.some(target => target.toLowerCase() === normalizedCategoryName);
        });
  
        console.log('Filtered categories:', filteredCategories);
  
         const level_id = levels.length > 0 ? levels[4].level_id : "Loading..."
    
        if (level_id) {
          const basedOnLevel = filteredCategories.filter((category) => category.level_id === level_id);
          console.log("Based on Level:", basedOnLevel);
          setCategories(basedOnLevel);
        } else {
          console.log("Level ID not found");
        }
      
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    }, [authToken, levels]);
  
  
    useEffect(() => {
      fetchLevelData();
     },[]);
  
    useEffect(() => {
      if (levels.length > 0) {
        fetchCategoriesData();
      }
    }, [levels, fetchCategoriesData]);


    const level_name = levels.length > 0 ? levels[4].level_name : "Loading..."
    console.log(level_name)

    const Categories = ["ReadingQuiz",'Writing']




    return (
      <div className='JLPTQuiz_Container ' >
          <div className='col-md-12'>
          <div className='header_inner' >
    <div className='container'>
    <div className='row'>
        <div className='col-md-12'>
        <ArrowBackIosIcon onClick={() => navigate('/Learn')} className='icon_1' />
        <h2>Katakana Quiz </h2>
        <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
        </div>
        </div>
        </div>
        </div>
          </div>
  
       <div className="container JLPT_Quiz" style={{marginTop:"100px",marginBottom:"100px"}}>
        <div className="row">
          <div className="col-md-12">
          <div className="btn_JLPT" style={{textAlign:"left"}}>
          <button   className='mt-4 mb-4 ' style={{border:"1px", fontWeight:"600", fontSize:"25px", backgroundColor:"white"}}>{`${level_name}`}</button>
          </div>
            <div className="JLPTQuiz_btn d-flex justify-content-around  p-2 ">
              <Link to={"/QDontTry"} >
               <div className="JLPTQuiz-1 ">
               <GrEmptyCircle size={40} color='white' />
               </div>
               </Link>
               <Link to={"/QDontTry"} >
               <div className="JLPTQuiz-2 ">
           
               <FaRegCircle size={40} color='white' />
               </div>
               </Link>
               <Link to={"/QDontTry"} >
               <div className="JLPTQuiz-3">
               <IoTriangleOutline size={40} color='white'/>
               </div>
               </Link>
               <div className="JLPTQuiz-4">
               <FaRegTimesCircle size={40} color='white' />
               </div>
               <div className="JLPTQuiz-5"> 
                <HiOutlineDotsCircleHorizontal size={40} color='white' />
                </div>
            </div>
          </div>
          <div className="col-md-12">
  
             <div className="JLPT_Quiz_Progres_bar mt-3 bg-light p-2">
             <p style={{textAlign:"left", fontWeight:"500", fontSize:"20px"}}>Overall Progress</p>
             <ProgressBar now={now} label={`${now}%`} visuallyHidden variant='danger' className='JLPTQuiz_Progress_bar' />
             <p style={{textAlign:"right", fontWeight:"500", fontSize:"20px"}}>Total Attempted: 12 </p>
             </div>
            
      
          </div> 
        </div>
        <div className="row JLPT_Learning_Type mt-5 ">
          <div className="col-md-12 mt-5">
               <div className="row justify-content-center ">


               {categories.map((category,index) => ( 
                    <div  className=" JLPT_Reading col-md-3 me-3 mt-2 mb-2 " key={index}
                    
                    onClick={
                                           
                      () =>{ 
                          const category_name =  Categories[index];
                          const category_id = category.category_id;
                          navigate(`/${category_name}/${category_id}/${index+"i"}`)
                          }
                  } 
                    
                    >
                 <img src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`} alt="Penguine" className='JLPT_learn_img me-2' /><span className='JLPT_span'>{category.category_name}</span>
               </div>
                    ))
                  }
               </div>
          </div>
   
          </div>
       </div>
  
             <Footer /> 
      </div>
    )
  }



export default KatakanaQuiz